import 'flatpickr/dist/themes/material_blue.css'
import React, { useRef } from 'react'
import Flatpickr from 'react-flatpickr'
import { Form, InputGroup } from 'react-bootstrap'
import { BsCalendar4 } from 'react-icons/bs'
import moment from 'moment'
import { FaTimes } from 'react-icons/fa'

function DatepickerCustom({
  value,
  isClearable = true,
  onChange,
  disabled,
  minDate,
  maxDate
}) {
  const refComp = useRef(null)
  return (
    <InputGroup className="">
      {!disabled ? (
        <Flatpickr
          ref={refComp}
          style={{ padding: '0px 0px 0px 10px' }}
          disabled={false}
          value={value}
          onChange={onChange}
          className="form-control rounded-start border-end-0 p-0 ps-2"
          options={{
            altInput: true,
            altFormat: 'd/m/Y',
            dateFormat: 'Y-m-d',
            ...(minDate && minDate),
            ...(maxDate && maxDate)
          }}
        />
      ) : (
        <Form.Control
          className="border-end-0"
          value={value ? moment(value).format('DD/MM/YYYY') : ''}
          disabled={true}
        />
      )}

      <InputGroup.Text
        className={`border-start-0  ${
          disabled ? 'bg-disable ' : 'bg-white'
        } ps-2 pe-2`}
      >
        {value && isClearable && (
          <FaTimes
            style={{ color: '#b8b8b8' }}
            className={`me-2 ${!disabled && 'pointer-event'} `}
            onClick={() => {
              !disabled && refComp.current.flatpickr.clear()
            }}
          />
        )}

        <BsCalendar4 style={{ color: '#b8b8b8' }} />
      </InputGroup.Text>
    </InputGroup>
  )
}

export default DatepickerCustom
